import { InjectionToken } from '@angular/core';

export let CHECK_DUPLICATED_REGISTRATIONS = new InjectionToken<boolean>('CHECK_DUPLICATED_REGISTRATIONS');
export let IS_PRODUCTION = new InjectionToken<boolean>('IS_PRODUCTION');
